import { useEffect, useState } from 'react';
import useDebounce from './useDebounce';

const useResponsive = () => {
  // screen resolutions
  const [deviceState, setDeviceState] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    // update the state on the initial load
    onResizeHandler();

    // assign the event
    Setup();

    return () => {
      // remove the event
      Cleanup();
    };
    // eslint-disable-next-line
  }, []);

  // update the state on window resize
  const onResizeHandler = () => {
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 990;
    const isDesktop = window.innerWidth > 990;

    setDeviceState({ isMobile, isTablet, isDesktop });
  };

  // debounce the resize call
  const debouncedCall = useDebounce(onResizeHandler, 500);

  // add event listener
  const Setup = () => {
    window.addEventListener('resize', debouncedCall, false);
  };

  // remove the listener
  const Cleanup = () => {
    window.removeEventListener('resize', debouncedCall, false);
  };

  return deviceState;
};

export default useResponsive;
